import axios from "axios";

export const sendDataToEmailApi = async (data) => {
  // post request to the formspree server to send the provided data as an email to the admin
  // data (JSON): data object with { name (String), email (String), message (String)}
  try {
    const { res } = await axios.post("https://formspree.io/f/maygnqvj", data);
    return res;
  } catch (error) {
    throw error;
  }
};
